/*
 * in-page-anchor-links.js
 *   include on pages with internal page links
 *   adds scrolling to anchor
 *   adds css to anchors to handle fixed header issues
 *
 */

jQuery(document).ready(($) => {
    // add css to handle fixed header
    const height = $('.nav-primary').height();
    $('.pageAnchor').each(function () {
        $(this).css({
            display: 'block',
            visibility: 'hidden',
            height,
            'margin-top': -height,
        });
    });

    // handle scrolling w/animation
    const $html = $('html,body');
    $('.pageAnchorMenu a').on('click', function (e) {
        e.preventDefault();
        $html.animate(
            {
                scrollTop: $(`[name="${$.attr(this, 'href').substr(1)}"]`).offset().top,
            },
            900
        );
        return false;
    });
});
